<template>
    <div class="roleItem">
        <div
            v-if="newAdmin"
            class="roleItem-corner"
        />
        <div
            :title="roleName"
            class="roleTitle"
        >
            {{ roleName }}
            <span
                v-if="newAdmin"
                class="roleTitle-desc"
            >
                <v-tag
                    color="brand"
                    text="系统默认，不可更改"
                    size="large"
                />
                系统超级管理员拥有所有套餐的所有权限，权限固定且不可编辑；每个企业仅可以赋予一人该角色，人员更换需联系本人或企业管理员操作
            </span>
        </div>
        <div class="opera">
            <template v-if="exceedLimit">
                <v-tip
                    ref="overPermissionTip"
                    placement="top-end"
                >
                    该角色超出了你的权限范围，不可编辑
                </v-tip>
                <v-icon
                    v-tip:overPermissionTip
                    class="role-operate-icon"
                    name="info"
                />
            </template>
            <template v-else-if="editable">
                <div
                    :class="[roleStatus == 1 ? 'disabled' : '']"
                    class="opitem"
                >
                    <v-tip
                        ref="roleDel"
                        placement="top"
                    >
                        删除
                    </v-tip>
                    <v-icon
                        v-tip:roleDel.hover
                        @click="del"
                        class="role-operate-icon"
                        name="delete"
                    />
                </div>
                <div
                    :class="[roleStatus == 1 ? 'disabled' : '']"
                    class="opitem"
                >
                    <v-tip
                        ref="roleCopy"
                        placement="top"
                    >
                        复制
                    </v-tip>
                    <v-icon
                        v-tip:roleCopy.hover
                        @click="copy"
                        class="role-operate-icon"
                        name="copy"
                    />
                </div>
                <div
                    :class="[roleStatus == 1 ? 'disabled' : '']"
                    class="opitem"
                >
                    <v-tip
                        ref="roleEdit"
                        placement="top"
                    >
                        修改
                    </v-tip>
                    <v-icon
                        v-tip:roleEdit.hover
                        @click="edit"
                        class="role-operate-icon"
                        name="edit"
                    />
                </div>
            </template>
        </div>
        <div class="packages">
            <div class="roleIcon packIcon">
                <v-icon name="packages" />
            </div>
            <div class="packNum">
                套餐 ({{ packNum }})
            </div>
            <div class="pack-item-wrap">
                <div
                    v-for="(packName, key) in packages"
                    :key="key"
                    class="packItem"
                >
                    {{ packName }}
                </div>
            </div>
        </div>
        <div class="privs">
            <div class="roleIcon privIcon">
                <v-icon name="priv" />
            </div>
            <div class="privNum">
                权限 {{ priNum }}
            </div>
            <priv-ellipsis-list
                v-if="!expand"
                :pri-obj="priList"
            />
            <a
                @click="expandClick"
                href="javascript:void(0);"
                class="more"
            >
                <span class="moretext">{{ expandTxt }}<v-icon
                    :name="expandIcon"
                    class="moreicon"
                /></span>
            </a>
            <div
                v-if="!expand"
                style="height: 30px"
            />
            <priv-detail-list
                v-if="expand"
                :role-id="roleID"
            />
        </div>
        <!--下半部分-->
        <div
            v-if="roleStatus === 0 && newAdmin "
            :class="['roleMem', 'addAdmin']"
        >
            <v-button
                v-if="memNum == 0"
                @click="editsysAdmin"
                type="text"
                size="medium"
                class="addAdmin-button"
            >
                <v-icon
                    remote
                    name="basic_new_line"
                />
                添加
            </v-button>
            <span
                v-else
                :class="['addAdmin-text', memNum != 0 ? 'addAdmin-content' : '']"
            >
                <v-icon name="colleague" />
                <span class="addAdmin-name">{{ managerInfo && managerInfo.name }}</span>
                <span class="addAdmin-qq">{{ `(${managerInfo && managerInfo.kfext})` }}</span>
                <a
                    @click="updateSysAdmin('update')"
                    class="addAdmin-update"
                >转让</a>
                <a
                    @click="updateSysAdmin('remove')"
                    class="addAdmin-remove"
                >移除</a>
            </span>
            <span
                v-if="memNum == 0"
                class="addAdmin-tip"
            >仅企业管理员可以进行该操作</span>
        </div>
        <div
            v-else-if="roleStatus === 0 && !newAdmin "
            class="roleMem"
        >
            <div
                class="roleIcon colIcon"
            >
                <v-icon name="colleague" />
            </div>
            <div
                v-if="memNum === 0"
                class="colNum"
            >
                还未添加员工
            </div>
            <div
                v-else
                class="colNum"
            >
                共{{ memNum }}名员工
            </div>
            <div
                v-if="exceedLimit !== 1"
                style="margin-top:7px"
            >
                <a
                    v-if="memNum === 0"
                    @click="adminmem"
                    href="javascript:void(0);"
                    class="modifymem"
                >添加</a>
                <a
                    v-else
                    @click="adminmem"
                    href="javascript:void(0);"
                    class="modifymem"
                >管理</a>
            </div>
        </div>
        <div
            v-else-if="roleStatus === 1"
            class="roleMem"
        >
            <div class="loading roleIcon colIcon" />
            <div class="colloading">
                员工权限更新中
            </div>
            <div style="margin-top:7px">
                <a
                    @click="refreshList"
                    href="javascript:void(0);"
                    class="modifymem"
                >刷新</a>
            </div>
        </div>
        <div
            v-else-if="roleStatus === 2"
            class="roleMem"
        >
            <div class="success roleIcon colUpdateIcon" />
            <div class="colloading colNum">
                更新成功
            </div>
        </div>

        <admin-col
            v-if="showAdmin"
            v-model="showAdmin"
            :role-name="roleName"
            :is-x-t-role="isXTRole"
            :role-id="roleID"
            :role-data="roleData"
            @remove="rmColleageu"
            @add="modifymem"
        />
        <v-dialog
            v-if="showCopyDialog"
            v-model="showCopyDialog"
            :confirm-disabled="copyConfirmDisabled"
            :confirm-loading="copyConfirmLoading"
            @confirm="copyConfirm"
            title="输入角色名称"
            kind="confirm"
            status="primary"
        >
            <role-name-input
                ref="roleNameInput"
                :key="roleNameInputKey"
                @input="roleNameChange"
                clazz="role-copy-input"
            />
        </v-dialog>
        <v-dialog
            v-model="notSysAdminDialog"
            :class="['notSysAdminDialog', 'editAdminDialog']"
            kind="modal"
            status="modal"
        >
            <div class="editAdminDialog-title">
                {{ notPriTitle }}
            </div>
            <div class="notSysAdminDialog-content">
                企业管理员相关信息， <br>可点击<a class="notSysAdminDialog-content-link">企业管理-企业信息-企业管理员</a>查看
            </div>
        </v-dialog>
        <v-dialog
            v-model="updateSysAdminDialog"
            @confirm="confirmUpdateAdmin"
            :class="['updateAdminDialog', 'editAdminDialog']"
            :confirmKind="editSysManagerType !== 'add' ? 'warning' : 'primary'"
            kind="modal"
        >
            <div class="editAdminDialog-title">
                {{ editSysManagerType !== 'add' ? `系统超级管理员拥有企业全部权限，仅一人可被赋予该角色，请谨慎${editSysManagerType === 'update' ? '转让' : '移除'}` :
                    '系统超级管理员拥有企业全部权限，仅一人可被赋予该角色，更换或移除只能由本人或企业管理员处理，请谨慎操作' }}
            </div>
            <template
                slot="footer-actionbar-primary"
            >
                {{ editSysManagerType !== 'add' ? editSysManagerType === 'update' ? '确认转让' : '确认移除': '确认添加' }}
            </template>
        </v-dialog>
        <staff-select-dialog
            ref="editAdminStaff"
            :editSysAdmin="true"
            @onSubmit="onConfirm"
        />
        <v-dialog
            v-model="addRoleFailedDialog"
            :class="['addRoleFailedDialog', 'editAdminDialog']"
            kind="modal"
            status="modal"
        >
            <div class="editAdminDialog-title">
                套餐所剩配额不足，无法添加
            </div>
            <div>可以前往<a href="/mng/org">组织架构</a>页面查看套餐配额详情</div>
            <template
                slot="button-text"
            >
                知道了
            </template>
        </v-dialog>
        <v-dialog
            v-model="failedUpdateAdmin"
            :class="['failedUpdateAdmin', 'editAdminDialog']"
            kind="modal"
            status="modal"
        >
            <div class="editAdminDialog-title">
                {{ failedMessage }}
            </div>
        </v-dialog>
        <v-dialog
            v-model="hasOrgPrivDialog"
            @close="jumpFrontPage"
            :class="['hasOrgPrivDialog', 'editAdminDialog']"
            kind="modal"
            status="modal"
        >
            <div class="editAdminDialog-title">
                {{ editSysManagerType === 'update' ? `${selectedStaff && selectedStaff.name}
                已成为新的系统超级管理员` : '' }}您当前已经失去「权限角色」的权限，将直接回到首页
            </div>
            <template slot="button-text">
                好的
            </template>
        </v-dialog>
        <v-dialog
            v-model="updateAdminRoleDialog"
            :class="['updateAdminRole', 'editAdminDialog']"
            @confirm="updateAdminRole"
            kind="modal"
        >
            <div class="editAdminDialog-title">
                {{ editSysManagerType === 'update' ? '转让' : '移除' }}后，原帐号没有任何权限角色，无法使用，请选择一个角色
            </div>
            <div
                v-popper:selectRole.click
                class="optionsRoleList-header"
            >
                <span :class="['optionsRoleList-header-text', selectRoleName ? 'optionsRoleList-header-text-selected' : '']">
                    {{ selectRoleName || '选择角色' }}
                </span>
                <v-icon
                    class="{`v-select__header-arrow"
                    remote
                    name="arrow_down_small_line"
                />
            </div>
            <v-popper
                ref="selectRole"
                placement="bottom"

                priority="['bottom','left', 'right', 'top']"
            >
                <v-scroll-list
                    v-model="selectRoleId"
                    v-if="optionsRoleList.length"
                    :options="optionsRoleList"
                    :max="50"
                    :loading="isloading"
                    :no-more="noMore"
                    @fetch="getRoleList"
                    @select="handleSelect"
                    :maps="{
                        value: 'roleId',
                        text: 'roleName',
                    }"
                    selectable
                    class="rolelist-scroll-list"
                    style="width:328px;"
                >
                    <template slot="loadTxt">
                        loading...
                    </template>
                </v-scroll-list>
                <div
                    v-else
                    class="rolelist-nodata"
                >
                    <div class="rolelist-nodata-content">
                        <v-icon
                            name="default_search"
                            class="rolelist-nodata-icon"
                        />
                        <div class="rolelist-nodata-text">
                            当前没有可用角色
                        </div>
                        <a
                            class="rolelist-nodata-link"
                            target="_blank"
                            href="/mng/role/jumpcreate"
                        >前去创建</a>
                    </div>
                </div>
            </v-popper>
        </v-dialog>
        <v-dialog
            v-model="successAddRoleDialog"
            :class="['successAddRole', 'editAdminDialog']"
            @confirm="successAddRole"
            kind="modal"
        >
            <div class="editAdminDialog-title">
                已成功赋予新角色，是否继续{{ editSysManagerType === 'update' ? '转让' : '移除' }}
            </div>
            <template
                slot="footer-actionbar-primary"
            >
                {{ editSysManagerType === 'update' ? '继续转让' : '继续移除' }}
            </template>
        </v-dialog>
    </div>
</template>
<script>
import { ajax } from '@tencent/qd-lib';
import { Icon } from 'vhtml-ui';
import terminalPriCheck from 'src/cgi/terminalPriCheck';
import roleNameInput from '../role-name-input';
import privEllipsisList from '../priv-ellipsis-list';
import adminCol from '../admin-col';
import privDetailList from '../priv-detail-list';
import StaffSelectDialog from '../admin-col/staff-select-dialog.vue';
const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        roleNameInput,
        privEllipsisList,
        adminCol,
        privDetailList,
        StaffSelectDialog,
    },
    props: {
        oriData: {
            type: Object,
            default: () => {},
        },
        userinfo: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            roleData: {},
            expand: false,
            showAdmin: false,
            showCopyDialog: false,
            copyConfirmDisabled: true,
            copyConfirmLoading: false,
            copyRoleName: '',
            roleNameInputKey: 'rnik',
            // 无权限添加/转让/移除dialog
            notSysAdminDialog: false,
            // 添加系统管理员失败弹窗
            addRoleFailedDialog: false,
            // 有权限添加/转让/移除dialog
            updateSysAdminDialog: false,
            // 转让/移除失败dialog
            failedUpdateAdmin: false,
            // 转让/移除成功无组织架构权限
            hasOrgPrivDialog: false,
            // 转让选择角色弹窗
            updateAdminRoleDialog: false,
            // 角色列表
            optionsRoleList: [],
            isloading: false,
            noMore: false,
            // 角色列表总数量
            totalNum: 0,
            // 角色列表当前选中项
            selectRoleId: -1,
            selectRoleName: '',
            // 分页请求角色列表时的页码
            roleListPage: 0,
            // 当前选中的员工
            selectedStaff: {},
            // 区分系统管理员操作类型，update转让， remove移除， add添加
            editSysManagerType: '',
            failedMessage: '',
            successAddRoleDialog: false,
        };
    },

    computed: {
        managerInfo() {
            return this.roleData.managerInfo;
        },
        kfextList() {
            return this.roleData.kfextlist;
        },
        roleID() {
            return this.roleData.roleId;
        },
        roleName() {
            return this.roleData.roleName;
        },
        packages() {
            return this.roleData.packages;
        },
        packNum() {
            return Object.keys(this.roleData.packages).length;
        },
        priNum() {
            return this.roleData.priCount;
        },
        priList() {
            return this.roleData.priList;
        },
        memNum() {
            return this.roleData.memNum;
        },
        editable() {
            return this.roleData.editable;
        },
        exceedLimit() {
            return this.roleData.exceedLimit;
        },
        roleStatus() {
            return this.roleData.roleStatus;
        },
        expandTxt() {
            return this.expand ? '收起' : '展开';
        },

        expandIcon() {
            return this.expand ? 'arrowup' : 'arrowdown';
        },
        newAdmin() {
            return this.roleData.newAdmin;
        },

        // 是否是协同角色
        isXTRole() {
            let bool = false;
            for (const k in this.packages) {
                if (parseInt(k, 10) === 10002) {
                    bool = true;
                }
            }
            return bool;
        },
        notPriTitle() {
            return this.editSysManagerType === 'update' || this.editSysManagerType === 'remove' ? '仅系统超级管理员本人或企业管理员可以进行转让或移除，您没有权限进行该操作' : '仅企业管理员可以赋予该角色给员工，您没有权限进行该操作';
        },
    },
    watch: {
        optionsRoleList(val) {
            this.optionsRoleList = val;
        },
    },
    created() {
        // 进行数据拷贝
        this.roleData = JSON.parse(JSON.stringify(this.oriData));
    },
    mounted() {
        // this.getUpdateStatus();
    },
    methods: {
        handleSelect(val) {
            this.$refs.selectRole.hide();
            this.selectRoleName = val.roleName;
        },
        updateAdminRole() {
            const params = [];
            params.push(this.managerInfo && this.managerInfo.kfext);
            this.$ajax.write('/mng/role/addUser', { roleid: this.selectRoleId, memary: [...params] }).then(async (res) => {
                if (res && res.code === 0) {
                    this.$message.success('添加成功');
                    this.successAddRoleDialog = true;
                } else {
                    this.$message.error(res.message || '添加失败');
                }
            });
        },
        successAddRole() {
            if (this.editSysManagerType === 'update') {
                this.adminRoleTransfer();
            } else if (this.editSysManagerType === 'remove') {
                this.confirmRemoveAdmin();
            }
        },
        // 转让成功无组织架构权限
        jumpFrontPage() {
            window.location.href = '/mng/account/index';
        },
        // 确认转让/添加/移除
        confirmUpdateAdmin() {
            if (this.editSysManagerType === 'remove') {
                this.confirmRemoveAdmin();
            } else {
                this.$refs.editAdminStaff.show({
                    showQQTip: '',
                    roleId: this.roleId,
                });
            }
        },
        // 移除系统超级管理员
        confirmRemoveAdmin() {
            ajax.gatewayPost('/v1/role/adminRoleRemoveUser').then(async (res) => {
                if (res) {
                    if (res.code === 0) {
                        if (!this.userinfo.isAdmin) {
                            const hasOrgPrivStatus = await this.hasOrgPriv();
                            if (hasOrgPrivStatus) {
                                this.$message.success('移除成功');
                                this.refreshRoleList();
                            } else {
                                this.hasOrgPrivDialog = true;
                            }
                        } else {
                            this.$message.success('移除成功');
                            this.refreshRoleList();
                        }
                    } else if (res.code === 103013) {
                        this.needAddRole();
                    } else {
                        this.$message.error(res.message || '移除失败');
                    }
                }
            });
        },
        needAddRole() {
            this.totalNum = 0;
            this.optionsRoleList = [];
            this.selectRoleName = '';
            this.selectRoleId = -1;
            this.roleListPage = 0;
            this.noMore = false;
            this.getRoleList();
            this.updateAdminRoleDialog = true;
        },
        // 转让/移除系统超级管理员权限检测
        updateSysAdmin(val) {
            this.editSysManagerType = val;
            if (this.userinfo.isAdmin || this.self()) {
                this.updateSysAdminDialog = true;
            } else {
                this.notSysAdminDialog = true;
            }
        },
        // getUpdateStatus(){
        //     this.$ajax
        //         .get(frompwdUrl)
        //         .then(res => {
        //             if (res.code === 0) {
        //                 this.isShow
        //             } else {
        //                 this.$message.error(res.message || '系统错误，请重试');
        //             }
        //         })
        //         .catch(err => {
        //             this.$message.error(err.message || '系统错误，请重试');
        //         });
        // },
        onConfirm(selected) {
            this.$refs.editAdminStaff.hide();
            this.selectedStaff = selected.length && selected[0];
            // 新增系统管理员
            if (this.editSysManagerType === 'add') {
                selected.length && this.addManager();
            } else {
                // 是否能转让系统管理员
                selected.length && this.canTransfeManager();
            }
        },
        addManager() {
            ajax.gatewayPost('/v1/role/adminRoleAddUser', { staff: this.selectedStaff && this.selectedStaff.id }).then((res) => {
                const code = res && res.code;
                if (code === 0) {
                    this.$message.success('添加成功');
                    this.refreshRoleList();
                } else if (code === 103012) {
                    this.addRoleFailedDialog = true;
                } else {
                    this.$message.error(res.message || '添加失败');
                }
            });
        },
        canTransfeManager() {
            // 转让系统管理员检测
            ajax.gatewayGet('/v1/role/adminRoleTransDetect', { staff: this.selectedStaff.id, currStaff: this.managerInfo && this.managerInfo.kfext }).then((res) => {
                if (res && res.code === 0) {
                    const { canTrans } = res.data || -1;
                    if (canTrans === 2) {
                        const { reason } = res.data || '转让失败';
                        this.failedMessage = reason;
                        this.failedUpdateAdmin = true;
                    } else if (canTrans === 1) {
                        this.adminRoleTransfer();
                    } else if (canTrans === 0) {
                        this.needAddRole();
                    }
                } else {
                    this.$message.error((res && res.message) || '操作失败');
                }
            });
        },
        self() {
            const kfext = this.userinfo.kfext || '';
            const roleKfext = this.managerInfo && this.managerInfo.kfext;
            return roleKfext === kfext;
        },
        adminRoleTransfer() {
            ajax.gatewayPost('/v1/role/adminRoleTransfer', { staff: this.selectedStaff.id }).then(async (res) => {
                if (res && res.code === 0) {
                    if (!this.userinfo.isAdmin) {
                        const hasOrgPrivStatus = await this.hasOrgPriv();
                        // 组织架构权限
                        if (hasOrgPrivStatus) {
                            this.$message.success(`转让成功，${this.selectedStaff.name}已成为新的系统超级管理员`);
                            this.refreshRoleList();
                        } else {
                            this.hasOrgPrivDialog = true;
                        }
                    } else {
                        this.$message.success(`转让成功，${this.selectedStaff.name}已成为新的系统超级管理员`);
                        this.refreshRoleList();
                    }
                } else {
                    this.$message.error((res && res.message) || '操作失败');
                }
            });
        },
        getRoleList() {
            this.isloading = true;
            if (this.totalNum <= this.optionsRoleList.length && this.optionsRoleList.length !== 0) {
                this.noMore = true;
                return;
            }
            this.roleListPage += 1;
            ajax.gatewayGet('/v1/role/availableRoleList', { index: this.roleListPage, count: 10, staff: this.managerInfo && this.managerInfo.kfext }).then((res) => {
                if (res && res.code === 0) {
                    const { roleList, total } = res.data || [];

                    this.totalNum = total;
                    this.optionsRoleList = [...this.optionsRoleList, ...roleList];
                    this.isloading = false;
                } else {
                    this.$message.error((res && res.message) || '操作失败');
                }
            });
        },
        editsysAdmin() {
            this.editSysManagerType = 'add';
            // 管理员可添加
            if (this.userinfo.isAdmin) {
                this.updateSysAdminDialog = true;
            } else {
                this.notSysAdminDialog = true;
            }
        },
        hasOrgPriv() {
            return new Promise((resolve, reject) => {
                ajax.gatewayGet('/v1/account/privileges').then((res) => {
                    if (res && res.code === 0) {
                        const { adminPrivileges } = res.data || {};
                        resolve(adminPrivileges.find(item => item === 42) === 42);
                    }
                });
            });
        },
        adminmem() {
            this.showAdmin = true;
        },

        rmColleageu() {
            this.refreshInfo();
        },

        modifymem() {
            this.refreshInfo();
        },
        refreshList() {
            window.location.reload();
        },
        refreshInfo() {
            this.$ajax
                .read('/mng/role/roleList', {
                    roleId: this.roleID,
                })
                .then(
                    (res) => {
                        const { code, list, message } = res || {};
                        if (parseInt(code, 10) === 0) {
                            this.roleData = list && list[0];
                        } else {
                            this.$message.error(message || '刷新角色信息失败');
                        }
                    },
                    (error) => {
                        this.$message.error((error && error.message) || '请求出错');
                    },
                );
        },
        refreshRoleList() {
            this.$emit('refreshRoleList');
        },

        del() {
            const self = this;
            this.$confirm({
                title: '删除角色？',
                content: '删除后，该角色包含的所有员工将被清空。',
                status: 'warning',
                confirmText: '删除',
                cancelText: '取消',
                confirm() {
                    self.delRoleReq();
                },
            });
        },

        delRoleReq() {
            const { roleID } = this;
            terminalPriCheck('delRole', { roleID }, () => {
                this.$ajax
                    .write('/mng/role/delRole', {
                        roleID,
                    })
                    .then(
                        (res) => {
                            const { code, message } = res || {};
                            if (parseInt(code, 10) === 0) {
                                this.$message.success('删除成功');
                                this.$emit('delRoleSucc', roleID);
                            } else {
                                this.$message.error(message || '删除角色失败，请稍后重试');
                            }
                        },
                        (error) => {
                            this.$message.error(error || '请求出错');
                        },
                    );
            });
        },

        copy() {
            this.roleNameInputKey = `rnik${Date.now()}`;
            this.copyConfirmDisabled = true;
            this.copyConfirmLoading = false;
            this.showCopyDialog = true;
        },

        copyConfirm(e) {
            const errMsg = this.$refs.roleNameInput.getErrMsg();

            if (!errMsg) {
                this.copyRoleReq();
            }

            e.preventDefault();
        },

        copyRoleReq() {
            this.copyConfirmLoading = true;

            this.$ajax
                .write('/mng/role/roleCreate', {
                    type: 2,
                    roleId: this.roleID,
                    roleName: this.copyRoleName,
                }, { customFn: (res) => {
                    this.copyConfirmLoading = false;
                    this.$message.error(res.msg || res.message || '复制角色失败');
                } })
                .then(
                    (res) => {
                        const { roleId, msg } = res || {};
                        if (roleId) {
                            this.showCopyDialog = false;
                            this.$message.success('复制角色成功');
                            this.$emit('copyRoleSucc', roleId);
                        } else {
                            this.$message.error(msg || '复制角色失败');
                        }
                        this.copyConfirmLoading = false;
                    },
                    (error) => {
                        this.$message.error(error || '请求出错');
                        this.copyConfirmLoading = false;
                    },
                );
        },

        edit() {
            this.$router.push(`/mng/role/edit/${this.roleID}`);
            this.$refs.roleEdit.hide();
        },

        roleNameChange(val) {
            this.copyRoleName = val;
            if (val && val.length > 0) {
                this.copyConfirmDisabled = false;
            } else {
                this.copyConfirmDisabled = true;
            }
        },

        expandClick() {
            this.expand = !this.expand;
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
